import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from 'utils/history';
import loginUserReducer from 'pages/AppLogin/reducer';

export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({ router: connectRouter(history), auth: loginUserReducer, ...injectedReducers });
  return rootReducer;
}
